import type { Wallet, WalletTopUp } from '@/types/portal';
import { toKesEquivalent } from './invoice';

export interface WalletTotals {
  fundingKes: number;
  attentionCount: number;
  fundingCount: number;
}

const ATTENTION_STATUSES = ['Wallet inactive', 'Wallet frozen'];

/** Roll the funding wallet book up into the position shown in the KPIs. */
export function walletTotals(rows: Wallet[]): WalletTotals {
  const funding = rows.filter((wallet) => wallet.ownerType === 'Funding');
  return {
    fundingKes: funding.reduce((sum, wallet) => sum + toKesEquivalent(wallet.balance, wallet.currency), 0),
    attentionCount: funding.filter((wallet) => ATTENTION_STATUSES.includes(wallet.status)).length,
    fundingCount: funding.length,
  };
}

export function needsAttention(wallet: Wallet): boolean {
  return ATTENTION_STATUSES.includes(wallet.status);
}

export interface WalletFilter {
  owner: string;
  currency: string;
  markets: string[];
  query: string;
}

export function filterWallets(rows: Wallet[], filter: WalletFilter): Wallet[] {
  const text = filter.query.trim().toLowerCase();
  return rows.filter((wallet) => {
    if (filter.owner !== 'All' && wallet.ownerType !== filter.owner) return false;
    if (filter.currency !== 'All currencies' && wallet.currency !== filter.currency) return false;
    if (filter.markets.length > 0 && !filter.markets.includes(wallet.market)) return false;
    if (text) {
      const haystack = `${wallet.ownerName} ${wallet.currency} ${wallet.market}`.toLowerCase();
      if (!haystack.includes(text)) return false;
    }
    return true;
  });
}

/** Newest top-ups first. */
export function sortTopUps(rows: WalletTopUp[]): WalletTopUp[] {
  return [...rows].sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
}